'use client';
import { direction, Product, productCardType, ResponseType, shopServiceType } from '@/commonTypes';
import React, { useEffect, useState } from 'react';
import Api from '@/api';
import { useTranslations } from 'next-intl';
import ProductsServicesContent from '../../product/ProductsContent/productsServicesTemplate';
import { mockService, mockServiceList } from '@/mock/sample.json';

interface ContentType {
  data?: ResponseType<shopServiceType>;
  page?: string | number | null;
  limit?: number;
  params?: any;
  // category?: ResponseType<category>;
  activeCategory?: string | null;
  tagSlug?: string | null;
  type?: 'products' | 'services';
}

export default function ServicesContent({
  data,
  page,
  limit = 10,
  params,
  // category,
  activeCategory = '',
  tagSlug,
  type = 'services',
}: ContentType) {
  const tCommon = useTranslations('common');
  const [direction, setDirection] = useState<direction>('horizontal');

  // const sample = {
  //   id: 1,
  //   slug: 'yadak-center-pasdaran',

  //   title: 'مکانیکی تخصصی پاسداران',
  //   subtitle: 'brake pads',
  //   description:
  //     'لنت ترمز جلو برمبو مناسب خودروهای سواری با کیفیت ساخت بالا و عملکرد ترمزگیری عالی.',

  //   selected: true,
  //   discount: '20%',

  //   // image: {
  //   //   src: '/images/products/brake-pad.jpg',
  //   //   alt: 'لنت ترمز جلو برمبو اصلی',
  //   // },

  //   rating: 4.8,
  //   distance: '۱.۲ کیلومتر',

  //   price: 350000,
  //   closestTime: 'امروز ۱۶:۳۰',
  //   services: [
  //     {
  //       id: 1,
  //       title: 'تعویض روغن',
  //       slug: 'oil-change',
  //     },
  //     {
  //       id: 2,
  //       title: 'دیاگ',
  //       slug: 'diagnostics',
  //     },
  //     {
  //       id: 3,
  //       title: 'ترمز',
  //       slug: 'brake',
  //     },
  //   ],
  // };
  const sample = mockService;
  const initial = Array.from({ length: 10 }, (_, index) => ({
    ...sample,
    id: index + 1,
    slug: `service-${index + 1}`,
    randomNumber: Math.floor(Math.random() * 360),
    count: index,
  }));

  const [pageNumber, setPageNumber] = useState<number | string>(page ? Number(page) : 1);
  const [list, setList] = useState({ response: initial, response_details: { count: 20 } });
  const [categoryList, setCategoryList] = useState(mockServiceList);
  useEffect(() => {
    Api.serviceList({ start: 0, limit: 1000 })
      .then((res) => {
        // setCategoryList(res?.data?.response);
      })
      .catch((err) => {
        console.error('serviceList failed:', err);
      });
  }, []);
  const info = {
    breadcrumb: {
      items: [
        { label: 'خانه', to: '/' },
        { label: 'فروشگاه', to: '/shops' },
        { label: 'خدمات و تعمیرگاه‌ها' },
      ],
    },
    hero: {
      title: 'خدمات و تعمیرگاه‌های اطراف شما',
      text: 'تعویض روغن، بالانس و تنظیم فرمان، دیاگ، ترمز و بیشتر — رزرو نوبت آنلاین با انتخاب ساعت خالی.',
    },
    category: {
      title: 'نوع خدمت',
    },
    services: mockServiceList,
  };
  // const [list, setList] = useState(changeData(data));

  // useEffect(() => {
  //   if (data) {
  //     setList(changeData(data));
  //   }
  // }, [data]);
  useEffect(() => {
    setPageNumber(page ? page : 1);
  }, [page]);

  console.log('params1======', params);

  return (
    <ProductsServicesContent
      pageNumber={pageNumber}
      setPageNumber={setPageNumber}
      categoryList={categoryList}
      direction={direction}
      setDirection={setDirection}
      infiniteApi={Api.shopServicesLists}
      limit={limit}
      list={list}
      setList={setList}
      params={params}
      page={page}
      type={type}
      initialList={data}
      info={info}
      queryKey="service"
      path="/shop-services"
      // activeCategory={activeCategory}
    />
  );
}
